"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dispatcher_onAuthRequired = void 0;
const ts_common_1 = require("@nu-art/ts-common");
exports.dispatcher_onAuthRequired = new ts_common_1.Dispatcher('__onAuthRequiredListener');
